import { api } from '../client'
import { ENDPOINTS } from '../config'
import { ChildRecord } from '../types'

export interface CreateChildPayload {
    firstName: string
    lastName: string
    middleName?: string
    dateOfBirth: string
    picture: string
    allergies?: string[]
    genotype?: string
    gender: string
    bloodGroup?: string
    parents?: string[]
    alternativeContacts?: string[]
}

export type UpdateChildPayload = Partial<CreateChildPayload>

export const ChildrenService = {
    create: (payload: CreateChildPayload) =>
        api.post<ChildRecord>(ENDPOINTS.CHILDREN.CREATE, payload),

    update: (id: string, payload: UpdateChildPayload) =>
        api.patch<ChildRecord>(ENDPOINTS.CHILDREN.UPDATE(id), payload),

    remove: (id: string) => api.delete<unknown>(ENDPOINTS.CHILDREN.DELETE(id)),

    findById: (id: string) => api.get<ChildRecord>(ENDPOINTS.CHILDREN.BY_ID(id)),

    findByName: (name: string) =>
        api.get<ChildRecord[]>(ENDPOINTS.CHILDREN.BY_NAME(name)),

    findByDob: (dateOfBirth: string) =>
        api.get<ChildRecord[]>(ENDPOINTS.CHILDREN.BY_DOB(dateOfBirth))
}
